import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const lock: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M2.5-6h4v-1.5q-.002-.826-.594-1.406A1.9 1.9 0 0 0 4.5-9.5q-.831.002-1.422.594A1.91 1.91 0 0 0 2.5-7.5zm6.5.75v4.5q0 .316-.219.531A.72.72 0 0 1 8.25 0H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-.75v-4.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-6H1v-1.5q0-1.436 1.031-2.469C2.72-10.656 3.54-11 4.5-11q1.436 0 2.469 1.031Q7.999-8.936 8-7.5V-6h.25q.31 0 .531.219A.74.74 0 0 1 9-5.25m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "9",
  }
};

export const unlock: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13-7.5v2a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14H12a.52.52 0 0 1-.36-.14.52.52 0 0 1-.14-.36v-2q-.001-.826-.594-1.406A1.9 1.9 0 0 0 9.5-9.5q-.831.001-1.422.594A1.91 1.91 0 0 0 7.5-7.5V-6h.75q.31 0 .531.219A.74.74 0 0 1 9-5.25v4.5q0 .316-.219.531A.72.72 0 0 1 8.25 0H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-.75v-4.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-6H6v-1.5c0-.969.344-1.789 1.031-2.469C7.72-10.656 8.54-11 9.5-11q1.452 0 2.469 1.031A3.34 3.34 0 0 1 13-7.5m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "13",
  }
};
